import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  exportBtn: {
    padding: `0 ${theme.spacing(2)}px`,
    outline: 0,
    color: '#37474F',
  },
}));
